import styled from 'styled-components';
import {
    grayColor,
  } from "~/components/layout/Variables";

export const Card = styled.div`
  margin-top: 0rem;
`;

export const ModalContent = styled.div`
  background-color: #fff;
  padding: 0rem 1rem 1rem 1rem;
  text-align: center;
  border: 0px;

  justify-content: center;
  vertical-align: middle;

  p {
    margin-top: 0;
    margin-bottom: 0;

  }
`;

export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const TextQuantity = styled(SubTitle)`
  width: 100%;
  text-align: center;
  font-weight: bold;

  @media (max-width: 700px) {
    text-align: center;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  position:absolute;
  top:-42px;
  left:auto;
  right:-10px;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  color:#ffffff;
  cursor:pointer;
`;

export const ButtonOutline = styled.button`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 38px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.7rem;
  }
  span {
    padding-right: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
